import { c as _c } from "react/compiler-runtime";
import { Typography, Icon } from "@/shared/ui/atoms";
import { useSearchUiStore } from "@/features/search/model/ui/store";
import type { Region } from "@/shared/types/type/search";
interface RegionModalSideBarProps {
  selectedRegion: number;
  setSelectedRegion: (region: number) => void;
  regionList?: Region[];
  designVariant?: boolean;
}
const RegionModalSideBar = t0 => {
  const $ = _c(15);
  const {
    selectedRegion,
    setSelectedRegion,
    regionList: providedRegions,
    designVariant
  } = t0;
  const storedRegions = useSearchUiStore(_temp);
  const regionList = providedRegions ?? storedRegions;
  let t1;
  if ($[0] !== selectedRegion) {
    t1 = regionId => {
      if (selectedRegion === regionId) {
        return "text-[#1D1E20] font-semibold bg-[#F4F4F5]";
      }
    };
    $[0] = selectedRegion;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const getCheckedStyle = t1;
  let t2;
  if ($[2] !== designVariant || $[3] !== getCheckedStyle || $[4] !== regionList || $[5] !== selectedRegion || $[6] !== setSelectedRegion) {
    let t3;
    if ($[8] !== designVariant || $[9] !== getCheckedStyle || $[10] !== selectedRegion || $[11] !== setSelectedRegion) {
      t3 = region => <li key={region.id}><button type="button" aria-pressed={selectedRegion === region.id} className={`flex w-full text-left items-center justify-between gap-2 py-3 pl-5 pr-[10px] text-[#878A93] ${getCheckedStyle(region.id)}`} onClick={() => setSelectedRegion(region.id)}><Typography size={16} lineHeight={24} className={designVariant ? selectedRegion === region.id ? "font-bold" : "font-normal" : "font-medium"}>{region.name}</Typography><Icon src={designVariant ? "/images/home-v2/region-arrow.svg" : "/icons/direction-black.svg"} alt="" width={14} className={designVariant ? "shrink-0" : "rotate-180"} /></button></li>;
      $[8] = designVariant;
      $[9] = getCheckedStyle;
      $[10] = selectedRegion;
      $[11] = setSelectedRegion;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    t2 = regionList.map(t3);
    $[2] = designVariant;
    $[3] = getCheckedStyle;
    $[4] = regionList;
    $[5] = selectedRegion;
    $[6] = setSelectedRegion;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[13] !== t2) {
    t3 = <aside className="min-h-0 w-2/5 shrink-0 overflow-y-auto"><ul className="border-r border-[#EAEBEC]">{t2}</ul></aside>;
    $[13] = t2;
    $[14] = t3;
  } else {
    t3 = $[14];
  }
  return t3;
};
export default RegionModalSideBar;
function _temp(state) {
  return state.regionList;
}